import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
  Typography,
} from '@one-thd/sui-atomic-components';
import { Paragraph } from './Paragraph';
import {
  AccordionContainer,
  AccordionRow,
  StyledAccordionTitle,
  StyledAccordionBody,
} from '../styles';

const HowItWorksAccordion = (props) => {
  const { isMobile } = props;
  const [expanded, setExpanded] = useState();
  const handleChange = (accordion) => {
    if (!isMobile) {
      setExpanded(accordion !== expanded ? accordion : false);
    }
  };

  return (
    <AccordionContainer className="AccordionContainer">
      <div className="AccoridionHeader sui-font-w-bold sui-mb-3 sui-text-base">How it Works</div>
      <Accordion>
        <AccordionHeader aria-controls="accordion1-content" id="accordion1-header">
          <div className="sui-flex-auto sui-block">
            <Typography component="div" variant="body-lg" weight="bold" height="tight">
              Design and Purchase
            </Typography>
            <div className="sui-mt-1">
              <Typography variant="body-base" color="subtle">
                Step 1
              </Typography>
            </div>
          </div>
        </AccordionHeader>
        <AccordionBody>
          <div className="sui-text-wrap">
            <Paragraph>
              Design your free countertop estimate online to fit your style and budget. Build with
              confidence knowing that a professional will double check the measurements entered to
              ensure a perfect fit.
            </Paragraph>

            <Paragraph>
              Not ready to build? Purchase samples online or pick up free in store.
            </Paragraph>

            <Paragraph>
              If you need assistance, you can schedule your free in-store design consultation to
              confirm design and installation decisions. When you’re ready you can purchase your
              project quote online and schedule an in-home professional measure.
            </Paragraph>

            <Paragraph className="sui-font-bold">
              Call <a href="tel:8884698956">888-469-8956</a> for free expert assistance throughout
              the process.
            </Paragraph>
          </div>
        </AccordionBody>
      </Accordion>

      <Accordion>
        <AccordionHeader aria-controls="accordion2-content" id="accordion2-header">
          <div className="sui-flex-auto sui-block">
            <Typography component="div" variant="body-lg" weight="bold" height="tight">
              Professional Measure
            </Typography>
            <div className="sui-mt-1">
              <Typography variant="body-base" color="subtle">
                Step 2
              </Typography>
            </div>
          </div>
        </AccordionHeader>
        <AccordionBody>
          <div className="sui-text-wrap">
            <Paragraph>
              A Home Depot Authorized Service Provider will contact you within two business days to
              schedule your professional measurement session. They will come to your home to measure
              your space and create a template for you to approve that ensures a perfect fit.
            </Paragraph>

            <Paragraph>
              If the measurement and specifications you enter in the build and buy estimate are
              changed, the professional will adjust the cost accordingly.
            </Paragraph>
          </div>
        </AccordionBody>
      </Accordion>

      <Accordion>
        <AccordionHeader aria-controls="accordion3-content" id="accordion3-header">
          <div className="sui-flex-auto sui-block">
            <Typography component="div" variant="body-lg" weight="bold" height="tight">
              Deliver and Install
            </Typography>
            <div className="sui-mt-1">
              <Typography variant="body-base" color="subtle">
                Step 3
              </Typography>
            </div>
          </div>
        </AccordionHeader>

        <AccordionBody>
          <div className="sui-text-wrap">
            <Paragraph>
              Once your new custom countertops have been fabricated, the installer will remove your
              existing countertops if needed and install new countertops. Your countertop will be
              created, delivered, and installed based on the professional, precise template –
              typically within two weeks of your measurement.
            </Paragraph>

            <Paragraph className="sui-font-bold">
              Delivery and basic installation are included in price.
            </Paragraph>
          </div>
        </AccordionBody>
      </Accordion>
    </AccordionContainer>
  );
};

HowItWorksAccordion.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default HowItWorksAccordion;
